export enum ProductTypeEnum {
  ComprehensiveLifeInsurance = "CLI",
  SuperSimpleLifeInsurance = "SSLI",
}
